const parseHeadersLink = (link) => {
  if (link) {
    const linkArray = link.split(",");
    const lastPage = linkArray[linkArray.length - 1].split("page=")[1].slice(0, 1);
    return Number(lastPage);
  } else {
    return 1;
  }
};

export default parseHeadersLink;
